import React, { useContext, useRef, useState } from 'react';
import message from 'antd/lib/message';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { useQuery } from 'react-query';
import { FirebaseContext } from '../../context/FirebaseContext';
import { getAllHolidays } from '../../NecttosComp/APICaller/ApiServices';
import SearchableImput from '../../NecttosComp/Input/SearchableImput';
import moment from 'moment';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import Input from '../../NecttosComp/Input/Input';
import { Table, Thead, Th, Tbody, Tr, Td } from '../../NecttosComp/Table/Table';
import Input2 from '../../NecttosComp/Input/Input2';
import Instruction from '../../Documentation/Instruction';

export const Holidays = ({ onClose }) => {
	const { collegeId, collegeList } = useContext(FirebaseContext);
	const componentRef = useRef();
	const selectedCollege = collegeList?.find((x) => x.collegeId === collegeId);
	const { data = [], refetch } = useQuery('getAllHolidays', getAllHolidays(collegeId));
	const [isLoading, setIsLoading] = useState(false);
	const [showForm, setShowForm] = useState(false);
	const [state, setState] = useState({});
	const [searchTerm, setSearchTerm] = useState('');

	const manageHolidays = async () => {
		try {
			setIsLoading(true);
			if (!state.startDate) {
				throw new Error('Start Number is Empty');
			}
			const instance = await getAxiosTokenInstance();
			let resp;
			resp = await instance.post('/college/action/postHolidays', {
				collegeId,
				startDate: state?.startDate,
				endDate: state?.endDate,
				naration: state?.naration,
				_id: state?._id,
			});
			if (resp.data.statusCode !== 200) {
				throw new Error(resp.data.message || 'API Error');
			} else {
				setState({
					...state,
					startDate: '',
					endDate: '',
					naration: '',
					_id: '',
				});
				refetch();
			}
		} catch (error) {
			message.error(error?.response?.data?.message || error?.message || 'API Error');
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<Main width='100%' height='100%' title='Holidays Management'>
			<Header>
				<div className='flex'>
					<div className='w-[400px] mr-4'>
						<Input2 type='text' fieldName='Search Naration' returnKey='narationSearch' state={{ narationSearch: searchTerm }} setState={({ narationSearch }) => setSearchTerm(narationSearch)} className='w-full' />
					</div>
				</div>
				<div className='flex'>
					<Button
						type='update'
						onClick={() => {
							setState({
								startDate: '',
								endDate: '',
								naration: '',
								_id: '',
							});
							setShowForm(true);
						}}>
						Add New
					</Button>

					<Button
						type='fetch'
						onClick={() => {
							refetch();
						}}>
						Reload
					</Button>
					<Button type='print' tableRef={componentRef.current}>
						Print
					</Button>
					<Instruction keyId={'holidays'} />
					{!isLoading && (
						<Button type='close' onClick={onClose}>
							Close
						</Button>
					)}
				</div>
			</Header>

			<Body>
				<div ref={componentRef} className='printable bg-slate-100 dark:bg-neutral-900 rounded-lg h-full overflow-x-auto'>
					<div className='min-w-[800px] flex flex-col rounded-[25px] p-[1%] z-[200]'>
						{/* <h5 className='text-[30px] w-full self-center dark:text-slate-100 m-6'>Holidays Management</h5> */}

						<Table width='100%' innerWidth={['5%', '20%', '20%', '50%', '5%']}>
							<Thead>
								<Tr>
									<Th position={0} textAlign='center'>
										Sn
									</Th>
									<Th position={1}>Start Date</Th>
									<Th position={2}>End Date</Th>
									<Th position={3}>Naration</Th>
									<Th position={4}></Th>
								</Tr>
							</Thead>

							<Tbody height='85vh'>
								{data
									?.filter((item) => item.naration?.toLowerCase().includes(searchTerm.toLowerCase()))
									.map((item, i) => (
										<Tr key={item._id} index={i}>
											<Td position={0} index={i} textAlign='center'>
												{i + 1}
											</Td>
											<Td position={1} index={i}>
												{moment(new Date(item?.startDate)).format('ddd, DD MMM YYYY')}
											</Td>
											<Td position={2} index={i}>
												{moment(new Date(item?.endDate)).format('ddd, DD MMM YYYY')}
											</Td>
											<Td position={3} index={i}>
												{item.naration}
											</Td>
											<Td position={4} index={i}>
												<div className='print:hidden'>
													<Button
														type='edit'
														onClick={() => {
															setShowForm(true);
															setState({
																startDate: item?.startDate || '',
																endDate: item?.endDate || '',
																naration: item?.naration || '',
																_id: item?._id || '',
															});
														}}>
														Edit
													</Button>
												</div>
											</Td>
										</Tr>
									))}
							</Tbody>
						</Table>
					</div>
				</div>
			</Body>

			{showForm && (
				<Main title={state._id ? 'Edit' : 'Add New'} width='50%' height='80%'>
					<div>
						<Input2 type='date' fieldName='Start Date' returnKey='startDate' state={state} setState={setState} className='w-full' />

						<Input2 type='date' fieldName='End Date' returnKey='endDate' state={state} setState={setState} className='w-full' />

						<SearchableImput keyData={'naration'} titleData={'Discription'} collection={'holidays'} stateData={state} setStateData={setState} />

						<div className='flex justify-between'>
							<Button
								type='close'
								onClick={() => {
									setShowForm(false);
									setState({
										...state,
										ddcNumber: '',
										subject: '',
										ddcSubject: '',
										mainDepartment: '',
										_id: '',
										alert: '',
									});
								}}>
								Cancel
							</Button>
							<Button
								type='submit'
								onClick={() => {
									manageHolidays();
								}}>
								Submit
							</Button>
						</div>
					</div>
				</Main>
			)}
		</Main>
	);
};
